<template>
  <div class="Addperson addCommon" style="height: 100%">
    <div class="return">
      <i class="el-icon-back" @click="goReturn">{{$t('LanguageLib.Return')}}</i>
      <span class="border"></span>
      <span class="title">{{ titleType }}</span>
    </div>
    <div class="content">
      <el-button @click="submit('ruleForm')" type="primary" class="searchBtn" :loading="loadingSave" style="margin-bottom: 7px;">{{$t('LanguageLib.SAVE')}}</el-button>
      <el-divider direction="vertical" v-if="$route.query.type == 'edit'"></el-divider>
      <el-button type="text" v-if="$route.query.type == 'edit'" @click="resetPassword">{{$t('LanguageLib.RESET_PASSWORD')}}</el-button>
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="0px" class="ruleForm">
        <h4>{{$t('LanguageLib.BASIC_CONFIGURATION')}}</h4>
        <div class="contentTop">
            <el-checkbox v-model="status">{{$t('LanguageLib.WHETHER_LOCKED')}}</el-checkbox>
            <el-checkbox v-model="ruleForm.isAdmin">{{$t('LanguageLib.ADMINISTRATOR')}}</el-checkbox>
            <el-checkbox v-model="ruleForm.isLoginProtection">{{$t('LanguageLib.LOGIN_PROTECTION')}}</el-checkbox>
        </div>
        <div class="positionInfo" v-if="$route.query.type == 'add'">
          <h4>{{$t('LanguageLib.JOB_INFORMATION')}}</h4>
          <div class="infoForm">
            <div class="parent" style="float: left;">
              <p class="drawerText"><span class="colorRed">*</span>&nbsp;{{$t('LanguageLib.ORGANIZATION')}}</p>
              <el-form-item prop="userProfileDto.defaultUDPDto.domainId" style="position: relative">
                <el-input style="width: 320px;" class="TeInput" :readonly="true" v-model="currentDomainName" :placeholder="$t('LanguageLib.PLEASE_CHOOSE')">
                  <el-button @click="openOrgList" slot="append" :style="styleStr" icon="el-icon-more"></el-button>
                </el-input>
                <span v-if="currentDomainName.slice(0, 3) === 'wx|' && JSON.parse($commonfun.localStorage.getitem('qyuser'))" style="cursor: no-drop;display: inline-block;width: 248px;height: 36px;position: absolute;left: 1px;top: 1px;background-color: #fff;border-radius: 5px;z-index: 9;">
                  <ww-open-data style="position: absolute;top: 1px;left: 14px;background: #fff;height: 36px;line-height: 36px;width: 232px;overflow: hidden;"  type="departmentName" :openid="currentDomainName.slice(3)"></ww-open-data>
                </span>
              </el-form-item>
            </div>
            <div class="parent" style="position: relative;">
              <p class="drawerText"><span class="colorRed">*</span>&nbsp;{{$t('LanguageLib.ROLES')}}</p>
              <el-form-item prop="userProfileDto.defaultUDPDto.roleId">
                <el-select style="width: 320px;" filterable v-model="ruleForm.userProfileDto.defaultUDPDto.roleId" clearable :placeholder="$t('LanguageLib.PLEASE_CHOOSE')">
                  <el-option
                    v-for="item in roleList"
                    :key="item.roleId"
                    :label="item.roleName"
                    :value="item.roleId">
                  </el-option>
                </el-select>
                <el-checkbox v-model="roleFilter" @change="changeRoleFilter">{{$t('LanguageLib.z_info_common_000084')}}</el-checkbox>
              </el-form-item>
              <el-form-item style="position: absolute;top: 21px;" v-if="ruleForm.userProfileDto.defaultUDPDto.domainId == ''">
                <el-input style="width: 320px;" :readonly="true" :placeholder="$t('LanguageLib.PLEASE_CHOOSE')" @click.native="showTit">
                </el-input>
              </el-form-item>
            </div>
          </div>
        </div>
        <div class="positionInfo" v-if="$route.query.type == 'edit'">
          <h4>{{$t('LanguageLib.JOB_INFORMATION')}}</h4>
          <div class="parent">
            <div class="infoForm">
              <p class="drawerText">{{$t('LanguageLib.z_info_common_000074')}}</p>
              <el-form-item style="margin-bottom: 3px;">
                <el-input maxlength="100" style="width: 320px;" :placeholder="$t('LanguageLib.PleaseEnter')" v-model="ruleForm.userProfileDto.DisplayPosition">
                </el-input>
              </el-form-item>
              <p style="font-size: 12px;font-weight: 400;color: #909399;line-height: 14px;" v-show="ruleForm.userProfileDto.DisplayPosition">{{$t('LanguageLib.CURRENT_POSITION')}}: <span>{{ruleForm.userProfileDto.DisplayPosition}}</span></p>
              <p style="font-size: 12px;font-weight: 400;color: #909399;line-height: 14px;" v-show="!ruleForm.userProfileDto.DisplayPosition">{{$t('LanguageLib.CURRENT_POSITION')}}: <span v-html="$commonfun.RenderWxName('departmentName', domainName)"></span>&nbsp;<span>{{roleName}}</span></p>
            </div>
          </div>
        </div>
        <div class="contentInfo">
          <h4>{{$t('LanguageLib.BASIC_INFORMATION')}}</h4>
          <div class="infoForm">
            <div class="parent">
              <p class="drawerText"><span class="colorRed">*</span>&nbsp;{{$t('LanguageLib.ACCOUNT')}}</p>
              <el-form-item prop="userAccount">
                <el-input style="width: 320px;" :placeholder="$t('LanguageLib.PleaseEnter')" v-model="ruleForm.userAccount" maxlength="20">
                </el-input>
              </el-form-item>
            </div>
            <div class="parent" style="position: relative;">
              <p class="drawerText"><span class="colorRed">*</span>&nbsp;{{$t('LanguageLib.NAME')}}</p>
              <el-form-item prop="userProfileDto.firstName" style="margin-bottom: 0px;white-space: nowrap;">
                <el-input style="width: 320px;" :placeholder="$t('LanguageLib.PleaseEnter')" v-model="ruleForm.userProfileDto.firstName" maxlength="20" @keyup.native="btKeyUp">
                </el-input>
                <span v-if="JSON.parse($commonfun.localStorage.getitem('qyuser')) && showQyUserName" style="cursor: no-drop;display: inline-block;width: 318px;height: 36px;position: absolute;left: 1px;top: 2px;background-color: #f5f7fa;border-radius: 5px;z-index: 9;">
                  <ww-open-data style="position: absolute;top: 1px;left: 14px;background: #f5f7fa;height: 36px;line-height: 36px;width: 290px;overflow: hidden;"  type="userName" :openid="wxUserid"></ww-open-data>
                </span>
                <span v-if="!JSON.parse($commonfun.localStorage.getitem('qyuser')) && showQyUserName" style="cursor: no-drop;display: inline-block;width: 318px;height: 36px;position: absolute;left: 1px;top: 2px;background-color: #f5f7fa;border-radius: 5px;z-index: 9;">
                  <span style="position: absolute;top: 1px;left: 14px;background: #f5f7fa;height: 36px;line-height: 36px;width: 290px;overflow: hidden;">wx|{{wxUserid}}</span>
                </span>
                <div style="display: inline-block;position: absolute;height: 40px;">
                  <el-checkbox v-if="wxUserid" v-model="showQyUserName" style="margin-left: 10px;line-height: 20px;position: absolute;top: 0;">{{$t('LanguageLib.SHOW_QY_USERNAME')}}</el-checkbox>
                  <p v-if="$commonfun.localStorage.getitem('qyuser') === 'true' && wxUserid" style="position: absolute;font-size: 12px;font-weight: 400;color: rgb(144, 147, 153);line-height: 20px;top: 20px;left: 10px;"><span>{{$t('LanguageLib.QY_USERNAME')}}:</span>&nbsp;&nbsp;<span v-html="$commonfun.RenderWxName('userName', 'wx|' + wxUserid)">></span></p>
                  <p v-if="$commonfun.localStorage.getitem('qyuser') === 'false' && wxUserid" style="position: absolute;font-size: 12px;font-weight: 400;color: rgb(144, 147, 153);line-height: 20px;top: 20px;left: 10px;"><span>{{$t('LanguageLib.QY_USERNAME')}}:</span>&nbsp;&nbsp;<span>{{$t('LanguageLib.QY_CANNOT_GET')}}</span></p>
                </div>
              </el-form-item>
            </div>
            <div class="parent">
              <p class="drawerText"><span class="colorRed">*</span>&nbsp;{{$t('LanguageLib.STATUS')}}</p>
              <el-form-item prop="StateValue">
                <el-select style="width: 320px;" v-model="ruleForm.StateValue" clearable :placeholder="$t('LanguageLib.PLEASE_CHOOSE')">
                  <el-option
                    v-for="item in userStatesList"
                    :key="item.stateValue"
                    :label="item.description"
                    :value="item.stateValue">
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
            <div class="parent">
              <p class="drawerText">{{$t('LanguageLib.GENDER')}}</p>
              <el-form-item>
                <el-select style="width: 320px;" v-model="ruleForm.userProfileDto.gender" clearable :placeholder="$t('LanguageLib.PLEASE_CHOOSE')">
                  <el-option
                    v-for="item in UserGenderList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
            <div class="parent">
              <p class="drawerText">{{$t('LanguageLib.SUPERIOR')}}</p>
              <el-form-item style="position: relative">
                <el-input style="width: 320px;" class="TeInput" :readonly="true" v-model="reportToName" :placeholder="$t('LanguageLib.PLEASE_CHOOSE')">
                  <el-button @click="superior" class="openOrgList" slot="append" :style="styleStrRegion" icon="el-icon-more"></el-button>
                </el-input>
                <span v-if="reportToName.slice(0, 3) === 'wx|' && JSON.parse($commonfun.localStorage.getitem('qyuser'))" style="cursor: no-drop;display: inline-block;width: 248px;height: 36px;position: absolute;left: 1px;top: 1px;background-color: #fff;border-radius: 5px;z-index: 9;">
                  <ww-open-data style="position: absolute;top: 1px;left: 14px;height: 36px;line-height: 36px;width: 220px;overflow: hidden;"  type="userName" :openid="reportToName.slice(3)"></ww-open-data>
                </span>
              </el-form-item>
            </div>
            <div class="parent">
              <p class="drawerText">{{$t('LanguageLib.BIRTHDAY')}}</p>
              <el-form-item>
                <el-date-picker
                  :picker-options="pickerOptions"
                  style="width: 320px;"
                  v-model="BirthDate"
                  type="date"
                  :placeholder="$t('LanguageLib.CHOICE_DATE')"
                  value-format="yyyy-MM-dd">
                </el-date-picker>
              </el-form-item>
            </div>
            <div class="parent">
              <p class="drawerText">{{$t('LanguageLib.EXPIRATION_DATE')}}</p>
              <el-form-item>
                <el-date-picker
                  style="width: 320px;"
                  v-model="ruleForm.endDate"
                  type="date"
                  :placeholder="$t('LanguageLib.CHOICE_DATE')"
                  value-format="yyyy-MM-dd">
                </el-date-picker>
              </el-form-item>
            </div>
          </div>
        </div>
        <div class="contentContact">
          <h4>{{$t('LanguageLib.WORK_INFO')}}</h4>
          <div class="infoForm">
            <div class="parent">
              <p class="drawerText">{{$t('LanguageLib.CONTACT_NUMBER')}}</p>
              <el-form-item>
                <el-input style="width: 320px;" :placeholder="$t('LanguageLib.PleaseEnter')" v-model="ruleForm.userProfileDto.AlternatePhone" maxlength="20">
                </el-input>
              </el-form-item>
            </div>
            <div class="parent">
              <p class="drawerText">{{$t('LanguageLib.MAILBOX')}}</p>
              <el-form-item prop="userProfileDto.workEmail">
                <el-input style="width: 320px;" :placeholder="$t('LanguageLib.PleaseEnter')" v-model="ruleForm.userProfileDto.workEmail" maxlength="50">
                </el-input>
              </el-form-item>
            </div>
            <div class="parent">
              <p class="drawerText"><span class="colorRed">*</span>&nbsp;{{$t('LanguageLib.USER_TYPE')}}</p>
              <el-form-item prop="userProfileDto.rank">
                <el-select style="width: 320px;" v-model="ruleForm.userProfileDto.rank" clearable :placeholder="$t('LanguageLib.PLEASE_CHOOSE')">
                  <el-option
                    v-for="item in UserTypeList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
            <div class="parent">
              <p class="drawerText">{{$t('LanguageLib.z_info_common_000076')}}</p>
              <el-form-item style="position: relative">
                <el-select style="width: 320px;" v-model="ruleForm.userProfileDto.interAreaCode" clearable :placeholder="$t('LanguageLib.PLEASE_CHOOSE')">
                  <el-option
                    v-for="item in interAreaCodeList"
                    :key="item.typeCode"
                    :label="item.typeDes"
                    :value="item.typeValue">
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
            <div class="parent" style="float: left;">
              <p class="drawerText">{{$t('LanguageLib.z_info_common_000068')}}</p>
              <el-form-item>
                <el-date-picker
                  style="width: 320px;"
                  v-model="ruleForm.userProfileDto.entryDate"
                  type="date"
                  :placeholder="$t('LanguageLib.CHOICE_DATE')"
                  value-format="yyyy-MM-dd">
                </el-date-picker>
              </el-form-item>
            </div>
            <div class="parent">
              <p class="drawerText">{{$t('LanguageLib.REMARK2')}}</p>
              <el-form-item>
                 <el-input
                  style="width: 320px;margin-bottom: 15px;"
                    maxlength="500"
                    type="textarea"
                    :rows="3"
                    placeholder=""
                    resize="none"
                    v-model="ruleForm.userProfileDto.Interest"
                  >
                  </el-input>
              </el-form-item>
            </div>
          </div>
        </div>
      </el-form>
    </div>
    <el-dialog :title="$t('LanguageLib.SELECT_SUPERIOR')" :visible.sync="dialogSuperior" class="superiorDialog dialogList" :before-close="closeDialog" :close-on-click-modal="false">
        <div class="operationSearch">
          <el-input
            placeholder=""
            prefix-icon="el-icon-search"
            v-model="searchValReportto"
            @keyup.enter.native="searchReporttoList"
          >
          </el-input>
        </div>
        <div class="tableParent">
        <el-table
          class="table-fixed"
          :data="tableData"
          stripe
          empty-text=" "
          @sort-change='sortChange'
          @row-click='rowClick'
          style="width: auto;"
          v-loading="loading"
          ref="table"
          height="100%">
          <el-table-column
            prop="2"
            :label="$t('LanguageLib.BIND_PHONE_NUMBER')"
            sortable="custom"
            min-width="240">
            <template slot-scope="scope" class="code">
              <el-tooltip class="code" effect="light" placement="top-start" >
                <span slot="content" type="userAccount">{{scope.row.userAccount}}</span>
                <span ref="toolTipItem" style="max-height: 55px;display: inline-block;display: inline-block;width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;    vertical-align: middle;" type="userAccount">{{scope.row.userAccount}}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            prop="1"
            :label="$t('LanguageLib.NAME')"
            sortable="custom"
            min-width="150">
            <template slot-scope="scope" class="code">
              <el-tooltip effect="light" placement="top-start" class="code">
                <span v-if="!$commonfun.iswx(scope.row.userName) || !JSON.parse($commonfun.localStorage.getitem('qyuser'))" slot="content" type="userName">{{scope.row.userName}}</span>
                <span v-if="!$commonfun.iswx(scope.row.userName) || !JSON.parse($commonfun.localStorage.getitem('qyuser'))" style="max-height: 55px;display: inline-block;display: inline-block;width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;vertical-align: middle;" ref="toolTipItem" type="userName">{{scope.row.userName}}</span>
                <span v-if="$commonfun.iswx(scope.row.userName) && JSON.parse($commonfun.localStorage.getitem('qyuser'))" slot="content" type="userName">
                  <ww-open-data slot="content" type="userName" :openid="scope.row.userName.slice(3)"></ww-open-data>
                </span>
                <span v-if="$commonfun.iswx(scope.row.userName) && JSON.parse($commonfun.localStorage.getitem('qyuser'))" style="max-height: 55px;display: inline-block;display: inline-block;width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;vertical-align: middle;" ref="toolTipItem" type="userName">
                  <ww-open-data slot="content" type="userName" :openid="scope.row.userName.slice(3)"></ww-open-data>
                </span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('LanguageLib.AGE')"
            min-width="80">
            <template slot-scope="scope">
              <el-tooltip effect="light" placement="top-start" >
                <span slot="content" type="age">{{scope.row.age}}</span>
                <span ref="toolTipItem" style="max-height: 55px;display: inline-block;display: inline-block;width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;    vertical-align: middle;" type="age">{{scope.row.age}}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            prop="3"
            :label="$t('LanguageLib.POSITION')"
            min-width="150">
            <template slot-scope="scope">
              <el-tooltip effect="light" placement="top-start" >
                <!-- 如果没有填入职位显示组织加角色 -->
                <span v-if="!scope.row.displayPosition" slot="content" type="displayPosition">
                  <span v-html="$commonfun.RenderWxName('departmentName', scope.row.domainName)"></span>&nbsp;<span>{{scope.row.roleName}}</span>
                </span>
                <span v-if="!scope.row.displayPosition" ref="toolTipItem" style="max-height: 55px;display: inline-block;display: inline-block;width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;vertical-align: middle;" type="displayPosition">
                  <span v-html="$commonfun.RenderWxName('departmentName', scope.row.domainName)"></span>&nbsp;<span>{{scope.row.roleName}}</span>
                </span>
                <!-- 如果有职位显示职位 -->
                <span v-if="scope.row.displayPosition" slot="content" type="displayPosition">{{scope.row.displayPosition}}</span>
                <span v-if="scope.row.displayPosition" ref="toolTipItem" style="max-height: 55px;display: inline-block;display: inline-block;width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;    vertical-align: middle;" type="displayPosition">{{scope.row.displayPosition}}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('LanguageLib.WORKING_AGE')"
            min-width="140">
            <template slot-scope="scope">
              <el-tooltip effect="light" placement="top-start" >
                <span slot="content" type="workYears">{{scope.row.workYears}}</span>
                <span ref="toolTipItem" style="max-height: 55px;display: inline-block;display: inline-block;width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;    vertical-align: middle;" type="workYears">{{scope.row.workYears}}</span>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[20, 50, 100]"
        :page-size="pageSizeReportto"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageTotal">
      </el-pagination>
    </el-dialog>
    <!--所在组织-->
    <el-dialog :title="$t('LanguageLib.SelectOrganization')" :visible.sync="dialogTableVisible" width="360px !important">
      <DomainTree @addcheck-treedata="getTreeCheckData" :orgData="orgData" :orgTreeData="orgTreeData" :oneNodeArr="oneNodeArr"></DomainTree>
      <el-button style="float:right;margin-top:15px;" @click="keepOrgData" type="primary" class="searchBtn">{{$t('LanguageLib.DETERMINE')}}</el-button>
    </el-dialog>
    <!--重置密码-->
    <el-dialog :title="$t('LanguageLib.RESET_PASSWORD')" :visible.sync="dialogReset" class="resetDialog dialogAdd" :before-close="closeDialogReset" :close-on-click-modal="false">
        <el-form>
          <div class="parent">
            <el-checkbox v-model="SendSMS">{{$t('LanguageLib.SEND_SMS_NOTIFICATION')}}</el-checkbox>
          </div>
          <div class="parent">
            <el-checkbox v-model="SendMail">{{$t('LanguageLib.SEND_MAIL_NOTIFICATION')}}</el-checkbox>
          </div>
          <div v-if="SendMail == true" >
            <div class="parent" style="padding-left: 12px;" v-for="item in ResetData" :key="item.label">
              <el-radio v-model="Lang" :label="item.label">{{item.name}}</el-radio>
            </div>
          </div>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="submitReset()">{{$t('LanguageLib.DETERMINE')}}</el-button>
        </div>
      </el-dialog>
  </div>
</template>

<script>
import basicdataApi from '../../api/basicdata'
import DomainTree from '@/components/DomainTree.vue'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
export default {
  name: 'AddStore',
  components: { DomainTree },
  props: ['currentPage', 'pageSize', 'parentId', 'searchText', 'sort', 'sortOrder', 'checkedStoreTypeData', 'checkedModeOperationData', 'checkedBrandData', 'orgName', 'type', 'sortNumber', 'orgTypeid', 'remark'],
  data () {
    var checkdomainId = (rule, value, callback) => {
      if (!value) {
        this.styleStr = 'width: 70px;height:40px;border-bottom: 1px solid #F56C6C;border-top: 1px solid #F56C6C;border-right: 1px solid #F56C6C;border-radius: 0 4px 4px 0;background-color: #D8DCE6;'
        return callback(new Error(this.$t('LanguageLib.ORGANIZATION') + this.$t('LanguageLib.CAN_NOT_BE_EMPTY')))
      } else {
        this.styleStr = 'width: 70px;height:40px;border-bottom: 1px solid #dcdfe6;border-top: 1px solid #dcdfe6;border-right: 1px solid #dcdfe6;border-radius: 0 4px 4px 0;background-color: #D8DCE6;'
        callback()
      }
    }
    var checkRoleId = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$t('LanguageLib.ROLES') + this.$t('LanguageLib.CAN_NOT_BE_EMPTY')))
      } else {
        callback()
      }
    }
    var checkuserAccount = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$t('LanguageLib.ACCOUNT') + this.$t('LanguageLib.CAN_NOT_BE_EMPTY')))
      } else {
        if (this.$commonfun.isNull(value)) {
          return callback(new Error(this.$t('LanguageLib.ACCOUNT') + this.$t('LanguageLib.CAN_NOT_BE_EMPTY')))
        } else {
          callback()
        }
      }
    }
    var checkfirstName = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$t('LanguageLib.NAME') + this.$t('LanguageLib.CAN_NOT_BE_EMPTY')))
      } else {
        if (this.$commonfun.isNull(value)) {
          return callback(new Error(this.$t('LanguageLib.NAME') + this.$t('LanguageLib.CAN_NOT_BE_EMPTY')))
        } else {
          callback()
        }
      }
    }
    var checkStateValue = (rule, value, callback) => {
      if (value === '' || value === undefined) {
        return callback(new Error(this.$t('LanguageLib.STATUS') + this.$t('LanguageLib.CAN_NOT_BE_EMPTY')))
      } else {
        callback()
      }
    }
    var checkworkEmail = (rule, value, callback) => {
      if (value !== '' && value !== null) {
        if (value.indexOf('@') === -1) {
          return callback(new Error(this.$t('LanguageLib.InfoMustContain')))
        } else {
          callback()
        }
      } else {
        callback()
      }
    }
    var checkRank = (rule, value, callback) => {
      if (value === '' || value === undefined) {
        return callback(new Error(this.$t('LanguageLib.USER_TYPE') + this.$t('LanguageLib.CAN_NOT_BE_EMPTY')))
      } else {
        callback()
      }
    }
    return {
      showQyUserName: false, // 显示企微姓名
      wxUserid: '', // 企微姓名id
      dialogReset: false, // 是否显示重置密码弹框
      ResetData: [
        {
          name: this.$t('LanguageLib.SIMPLIFIED_CHINESE'),
          label: '0'
        },
        {
          name: this.$t('LanguageLib.TRADITIONAL_CHINESE'),
          label: '1'
        },
        {
          name: this.$t('LanguageLib.ENGLISH'),
          label: '2'
        },
        {
          name: this.$t('LanguageLib.JAPANESE'),
          label: '3'
        },
        {
          name: this.$t('LanguageLib.KOREAN'),
          label: '4'
        }
      ],
      SendSMS: true, // 重置密码发送短信
      SendMail: false, // 重置密码发送邮件
      Lang: this.$commonfun.localStorage.getitem('OwnerLanguage'), // 发送邮件多语言
      status: false, // 是否锁定
      loading: false, // 上级人员列表loading
      tableData: [], // 上级人员列表
      interAreaCodeList: [], // 国别号list
      pageTotal: 0, // 数据总数
      roleList: [], // 角色列表
      userStatesList: [], // 人员状态列表
      BirthDate: '', // 生日
      UserGenderList: [{
        value: true,
        label: this.$t('LanguageLib.MALE')
      }, {
        value: false,
        label: this.$t('LanguageLib.FEMALE')
      }], // 用户性别
      UserTypeList: [{
        value: 1,
        label: this.$t('LanguageLib.RETAIL_MANAGEMENT')
      }, {
        value: 2,
        label: this.$t('LanguageLib.STORE_MANAGEMENT')
      }, {
        value: 3,
        label: this.$t('LanguageLib.Store_Staff')
      }, {
        value: 4,
        label: this.$t('LanguageLib.Non_Retail_System')
      }], // 用户类型列表
      currentDomainName: '', // 所在组织名称
      dialogSuperior: false, // 是否显示选择上级弹框
      reportToName: '', // 上级名称
      roleFilter: false, // 角色过滤
      ruleForm: {
        id: null, // 店铺Id
        status: 1, // 是否锁定
        isAdmin: false, // 是否管理员
        isLoginProtection: false, // 是否登录保护
        StateValue: 0, // 状态
        userProfileDto: {
          firstName: '', // 用户姓名
          gender: null, // 性别
          BirthYear: null, // 生日年
          BirthDate: '', // 生日月-日
          AlternatePhone: '', // 联系电话
          workEmail: '', // 邮箱
          rank: '', // 用户类型
          interAreaCode: null, // 国别号
          entryDate: '', // 入职日期
          Interest: '', // 备注
          DisplayPosition: '', // 职位(仅编辑时存在)
          defaultUDPDto: {
            domainId: '', // 组织id
            roleId: '' // 角色id
          } // 默认职位对象(仅添加时存在)
        }, // 用户配置对象
        userAccount: '', // 用户账号
        reportToId: '', // 上级用户id
        endDate: '' // 有效期
      },
      domainName: '', // 默认职位的组织
      roleName: '', // 默认职位的角色
      titleType: this.$t('LanguageLib.PERSONNEL_INFORMATION'),
      styleStr: 'width: 70px;height:40px;border-bottom: 1px solid #dcdfe6;border-top: 1px solid #dcdfe6;border-right: 1px solid #dcdfe6;border-radius: 0 4px 4px 0;background-color: #D8DCE6;',
      styleStrRegion: 'width: 70px;height:40px;border-bottom: 1px solid #dcdfe6;border-top: 1px solid #dcdfe6;border-right: 1px solid #dcdfe6;border-radius: 0 4px 4px 0;background-color: #D8DCE6;',
      dialogTableVisible: false, // 组织树视图的显示和隐藏
      filterText: '', // 过滤文本
      showStatusTitle: this.$t('LanguageLib.COLLAPSE'),
      showStatus: false, // 组织树默认收起
      searchTreeIds: [], // 通过接口获取企微id
      defaultProps: {
        children: 'childDomainTrees',
        label: 'domainName'
      },
      OrgTypeList: [],
      addremark: '',
      orgData: [], // 所在组织
      orgTreeData: [], // 所在组织
      oneNodeArr: [], // 所在组织
      addCheckparentName: '', // 所在组织
      addCheckparentId: '', // 所在组织
      addCheckDomainNo: '', // 所在组织
      editDomainNo: '',
      rules: {
        'userProfileDto.defaultUDPDto.roleId': [{
          validator: checkRoleId,
          trigger: 'blur'
        }],
        'userProfileDto.defaultUDPDto.domainId': [{
          validator: checkdomainId,
          trigger: 'blur'
        }],
        userAccount: [{
          validator: checkuserAccount,
          trigger: 'blur'
        }],
        'userProfileDto.firstName': [{
          validator: checkfirstName,
          trigger: 'blur'
        }],
        StateValue: [{
          validator: checkStateValue,
          trigger: 'change'
        }],
        'userProfileDto.workEmail': [{
          validator: checkworkEmail,
          trigger: 'blur'
        }],
        'userProfileDto.rank': [{
          validator: checkRank,
          trigger: 'change'
        }]
      },
      getreporttolist: (pageIndex, pageSize, sort, isAsc, userId, searchVal) => {
        this.loading = true
        // 请求列表接口数据
        basicdataApi.getReporttoList('post', '/user/reporttolist', { pageIndex, pageSize, sort, isAsc, userId, searchVal })
          .then(res => {
            this.tableData = res.data.data
            this.pageTotal = res.data.total
            this.loading = false
          })
          .catch(err => {
            this.$commonfun.console.log(err)
          })
      }, // 请求数据列表的函数
      currentPageReportto: 1, // 默认显示第1页数据
      pageSizeReportto: 20, // 默认每页显示20条数据
      sortReportto: 0, // 排序字段
      isAscReportto: true, // 排序方式逆序：false正序true
      searchValReportto: '', // 模糊搜索
      userIdReportto: this.$route.query.id, // 人员id
      pickerOptions: {
        disabledDate: (time) => {
          const nowData = new Date('1900,01,01')
          return time < nowData
        }
      },
      prevSort: 'ascending', // 记录前一次的排序状态（elementUI默认有三种，即descending，ascending和null）
      prevProp: '1', // 记录前一次的prop值
      loadingSave: false // 保存按钮加loding
    }
  },
  beforeRouteEnter (to, from, next) {
    NProgress.configure({
      easing: 'ease',
      speed: 500,
      showSpinner: false,
      trickleSpeed: 200,
      minimum: 0.3
    })
    NProgress.start()
    if (to.query.type === 'edit') {
      basicdataApi.getUserDetail('get', '/user/get',
        {
          id: to.query.id
        })
        .then(res => {
          NProgress.done()
          next(vm => {
            vm.ruleForm.id = to.query.id
            vm.ruleForm.status = res.data.status
            vm.status = vm.ruleForm.status === 0
            vm.ruleForm.isAdmin = res.data.isAdmin
            vm.ruleForm.isLoginProtection = res.data.isLoginProtection
            vm.ruleForm.userProfileDto.DisplayPosition = res.data.userProfileDto.displayPosition
            if (res.data.userProfileDto.defaultUDPDto) {
              vm.domainName = res.data.userProfileDto.defaultUDPDto.domainName
              vm.roleName = res.data.userProfileDto.defaultUDPDto.roleName
            } else {
              vm.domainName = ''
              vm.roleName = ''
            }
            vm.ruleForm.userAccount = res.data.userAccount
            if (res.data.userProfileDto.firstName) {
              res.data.userProfileDto.firstName.indexOf('wx|') >= 0 ? vm.showQyUserName = true : vm.showQyUserName = false
            }
            vm.ruleForm.userProfileDto.firstName = res.data.userProfileDto.firstName ? res.data.userProfileDto.firstName.replace('wx|', '') : ''
            vm.ruleForm.userProfileDto.gender = res.data.userProfileDto.gender
            vm.ruleForm.reportToId = res.data.reportToId
            vm.reportToName = res.data.reportToName === null ? '' : res.data.reportToName
            if (res.data.userProfileDto.birthYear) {
              vm.ruleForm.userProfileDto.BirthYear = res.data.userProfileDto.birthYear
              vm.ruleForm.userProfileDto.BirthDate = res.data.userProfileDto.birthDate
              vm.BirthDate = res.data.userProfileDto.birthYear + '-' + res.data.userProfileDto.birthDate
            }
            vm.ruleForm.endDate = res.data.endDate
            vm.ruleForm.userProfileDto.AlternatePhone = res.data.userProfileDto.alternatePhone
            vm.ruleForm.userProfileDto.workEmail = res.data.userProfileDto.workEmail
            vm.ruleForm.userProfileDto.rank = res.data.userProfileDto.rank === -1 ? '' : res.data.userProfileDto.rank
            vm.ruleForm.userProfileDto.entryDate = res.data.userProfileDto.entryDate
            vm.ruleForm.userProfileDto.Interest = res.data.userProfileDto.interest
            vm.wxUserid = res.data.wxUserid
            // 获取状态列表
            basicdataApi.GetUserStates('get', '/user/states', {
              pageIndex: 1,
              pageSize: 2147483647
            })
              .then(value => {
                vm.userStatesList = value.data
                vm.ruleForm.StateValue = res.data.stateValue
                for (let i = 0; i < vm.userStatesList.length; i++) {
                  if (vm.userStatesList[i].stateValue === 0) {
                    vm.userStatesList[i].description = vm.$t('LanguageLib.z_info_common_000087')
                  }
                  if (vm.userStatesList[i].stateValue === 1) {
                    vm.userStatesList[i].description = vm.$t('LanguageLib.Vacation')
                  }
                  if (vm.userStatesList[i].stateValue === 2) {
                    vm.userStatesList[i].description = vm.$t('LanguageLib.USER_STATUS_QUIT')
                  }
                }
              })
              .catch(err => {
                this.$commonfun.console.log(err)
              })
            // 获取国别号列表
            basicdataApi.GetInterAreaCode('get', '/BasicData/GetInterAreaCode', {
              pageIndex: 1,
              pageSize: 2147483647
            })
              .then(value => {
                vm.interAreaCodeList = value.data
                vm.ruleForm.userProfileDto.interAreaCode = res.data.userProfileDto.interAreaCode
              })
              .catch(err => {
                this.$commonfun.console.log(err)
              })
          })
        })
        .catch(err => {
          this.$commonfun.console.log(err)
        })
    } else {
      // 获取状态列表
      basicdataApi.GetUserStates('get', '/user/states')
        .then(value => {
          NProgress.done()
          next(vm => {
            vm.userStatesList = value.data // 状态列表
            for (let i = 0; i < vm.userStatesList.length; i++) {
              if (vm.userStatesList[i].stateValue === 0) {
                vm.userStatesList[i].description = vm.$t('LanguageLib.z_info_common_000087')
              }
              if (vm.userStatesList[i].stateValue === 1) {
                vm.userStatesList[i].description = vm.$t('LanguageLib.Vacation')
              }
              if (vm.userStatesList[i].stateValue === 2) {
                vm.userStatesList[i].description = vm.$t('LanguageLib.USER_STATUS_QUIT')
              }
            }
            // 获取国别号列表
            basicdataApi.GetInterAreaCode('get', '/BasicData/GetInterAreaCode', {
              pageIndex: 1,
              pageSize: 2147483647
            })
              .then(value => {
                vm.interAreaCodeList = value.data
              })
              .catch(err => {
                this.$commonfun.console.log(err)
              })
          })
        })
        .catch(err => {
          this.$commonfun.console.log(err)
        })
    }
  },
  created () {
    // 获取组织树列表
    basicdataApi.gettreelist('get', '/sysdomain/domainTree?showStore=' + true)
      .then(res => {
        this.orgData = res.data
        this.orgTreeData = this.$commonfun.toTree(res.data, 'childDomainTrees', 'id', 'parentDomainId')
        this.oneNodeArr.push(this.orgTreeData[0].id)
        if (this.$route.query.type === 'add') {
          for (let i = 0; i < this.orgData.length; i++) {
            if (this.orgData[i].id === this.$route.query.checkDomainId) {
              this.currentDomainName = this.orgData[i].domainName
              this.ruleForm.userProfileDto.defaultUDPDto.domainId = this.$route.query.checkDomainId
            }
          }
          this.ruleForm.userProfileDto.defaultUDPDto.roleId = ''
          basicdataApi.getRolesList('get', '/role/udplist?domainId=' + this.$route.query.checkDomainId + '&isOnlyDTR=' + this.roleFilter)
            .then(value => {
              this.roleList = value.data // 角色列表
            })
            .catch(err => {
              this.$commonfun.console.log(err)
            })
        }
      })
      .catch(err => {
        this.$commonfun.console.log(err)
      })
  },
  methods: {
    // 去除组织名称的特殊字符
    btKeyUp (e) {
      e.target.value = e.target.value.replace(/[\\/:：*?？"<>|]/g, '')
    },
    // 返回
    goReturn () {
      this.$router.push('/basicdata/personnelmanagement?currentPage=' + this.$route.query.currentPage + '&pageSize=' + this.$route.query.pageSize + '&checkDomainId=' + this.$route.query.checkDomainId + '&searchText=' + this.$commonfun.encodeUrl(this.$route.query.searchText) + '&sort=' + this.$route.query.sort + '&isAsc=' + this.$route.query.isAsc + '&gender=' + this.$route.query.gender + '&roleIds=' + this.$route.query.roleIds + '&ranks=' + this.$route.query.ranks + '&isAdmin=' + this.$route.query.isAdmin + '&isLoginProtection=' + this.$route.query.isLoginProtection + '&isLock=' + this.$route.query.isLock + '&fromPath=addPerson')
    },
    // 角色列表过滤
    changeRoleFilter () {
      this.ruleForm.userProfileDto.defaultUDPDto.roleId = ''
      if (this.ruleForm.userProfileDto.defaultUDPDto.domainId !== '') {
        basicdataApi.getRolesList('get', '/role/udplist?domainId=' + this.ruleForm.userProfileDto.defaultUDPDto.domainId + '&isOnlyDTR=' + this.roleFilter)
          .then(value => {
            this.roleList = value.data // 角色列表
          })
          .catch(err => {
            this.$commonfun.console.log(err)
          })
      }
    },
    // 打开所在组织组织树视图
    openOrgList () {
      this.dialogTableVisible = true
    },
    // 树组件传过来的数据-所在组织
    getTreeCheckData (data) {
      this.addCheckparentName = data.domainName
      this.addCheckparentId = data.id
      this.addCheckDomainNo = data.domainNo
    },
    // 保存树数据-所在组织
    keepOrgData () {
      this.dialogTableVisible = false
      this.currentDomainName = this.addCheckparentName
      this.ruleForm.userProfileDto.defaultUDPDto.domainId = this.addCheckparentId
      // 获取角色列表
      this.ruleForm.userProfileDto.defaultUDPDto.roleId = ''
      basicdataApi.getRolesList('get', '/role/udplist?domainId=' + this.ruleForm.userProfileDto.defaultUDPDto.domainId + '&isOnlyDTR=' + this.roleFilter)
        .then(value => {
          this.roleList = value.data // 角色列表
        })
        .catch(err => {
          this.$commonfun.console.log(err)
        })
    },
    // 员工上级
    superior () {
      this.dialogSuperior = true
      // 请求列表接口数据
      this.getreporttolist(this.currentPageReportto, this.pageSizeReportto, this.sortReportto, this.isAscReportto, this.userIdReportto, this.searchValReportto)
    },
    // 员工上级列表排序
    sortChange (column) {
      if (column.order !== null) {
        this.prevSort = column.order
        if (column.order === 'ascending') {
          this.isAscReportto = true
          this.prevSort = 'ascending'
        } else if (column.order === 'descending') {
          this.prevSort = 'descending'
          this.isAscReportto = false
        }
        if (this.prevProp !== column.prop) {
          var columns = this.$refs.table.columns.find(item => item.property === this.prevProp)
          columns.order = ''
        }
      }
      if (column.order === null) {
        column.column.order = this.prevSort === 'descending' ? 'ascending' : 'descending'
        column.order = this.prevSort === 'descending' ? 'ascending' : 'descending'
        this.prevProp = column.prop
        this.prevSort = column.column.order
        this.isAscReportto = column.column.order !== 'descending'
      }
      this.sortReportto = Number(column.prop)
      // 请求列表接口数据
      this.getreporttolist(this.currentPageReportto, this.pageSizeReportto, this.sortReportto, this.isAscReportto, this.userIdReportto, this.searchValReportto)
    },
    // 员工上级列表页数改变
    handleSizeChange (val) {
      this.pageSizeReportto = val
      // 请求列表接口数据
      this.getreporttolist(this.currentPageReportto, this.pageSizeReportto, this.sortReportto, this.isAscReportto, this.userIdReportto, this.searchValReportto)
    },
    // 员工上级列表每条页数改变
    handleCurrentChange (val) {
      this.currentPageReportto = val
      // 请求列表接口数据
      this.getreporttolist(this.currentPageReportto, this.pageSizeReportto, this.sortReportto, this.isAscReportto, this.userIdReportto, this.searchValReportto)
    },
    // 员工上级列表模糊搜索
    searchReporttoList () {
      this.currentPageReportto = 1
      // 请求列表接口数据
      this.getreporttolist(this.currentPageReportto, this.pageSizeReportto, this.sortReportto, this.isAscReportto, this.userIdReportto, this.searchValReportto)
    },
    // 点击上级人员
    rowClick (row, column, event) {
      this.reportToName = row.userName
      this.ruleForm.reportToId = row.id
      this.dialogSuperior = false
    },
    // 关闭对话框  清除校验
    closeDialog () {
      this.dialogSuperior = false
    },
    // 保存数据
    submit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // 是否锁定
          this.ruleForm.status = this.status === false ? 1 : 0
          // 姓名
          if (this.showQyUserName && this.wxUserid) {
            this.ruleForm.userProfileDto.firstName = 'wx|' + this.wxUserid
          } else {
            if (this.$route.query.type === 'edit') {
              if (this.ruleForm.userProfileDto.firstName.indexOf('wx|') === -1) {
                this.ruleForm.userProfileDto.firstName = this.ruleForm.userProfileDto.firstName.replace(/[\\/:：*?？"<>|]/g, '')
              }
            } else {
              this.ruleForm.userProfileDto.firstName = this.ruleForm.userProfileDto.firstName.replace(/[\\/:：*?？"<>|]/g, '')
            }
          }
          // 员工上级
          if (this.ruleForm.reportToId === '' || this.ruleForm.reportToId === null) {
            delete this.ruleForm.reportToId
          }
          // 生日
          if (this.BirthDate !== '') {
            this.ruleForm.userProfileDto.BirthYear = Number(this.BirthDate.slice(0, 4))
            this.ruleForm.userProfileDto.BirthDate = this.BirthDate.slice(5, 10)
          } else {
            this.ruleForm.userProfileDto.BirthYear = null
          }
          // 有效期
          this.ruleForm.endDate = this.ruleForm.endDate === '' ? null : this.ruleForm.endDate
          // 国别号
          this.ruleForm.userProfileDto.interAreaCode = this.ruleForm.userProfileDto.interAreaCode === '' ? null : this.ruleForm.userProfileDto.interAreaCode
          // 入职日期
          this.ruleForm.userProfileDto.entryDate = this.ruleForm.userProfileDto.entryDate === '' ? null : this.ruleForm.userProfileDto.entryDate
          this.loadingSave = true
          if (this.$route.query.type === 'add') {
            delete this.ruleForm.id
            delete this.ruleForm.userProfileDto.DisplayPosition
            basicdataApi.Checkcreate('get', '/user/checkcreate', this.ruleForm)
              .then(res => {
                basicdataApi.AddPerson('post', '/user/create', this.ruleForm)
                  .then(res => {
                    this.$message({
                      type: 'success',
                      message: this.$t('LanguageLib.ADDED_SUCCESSFULLY1')
                    })
                    this.$router.push('/basicdata/personnelmanagement?currentPage=' + this.$route.query.currentPage + '&pageSize=' + this.$route.query.pageSize + '&checkDomainId=' + this.$route.query.checkDomainId + '&searchText=' + this.$commonfun.encodeUrl(this.$route.query.searchText) + '&sort=' + this.$route.query.sort + '&isAsc=' + this.$route.query.isAsc + '&gender=' + this.$route.query.gender + '&roleIds=' + this.$route.query.roleIds + '&ranks=' + this.$route.query.ranks + '&isAdmin=' + this.$route.query.isAdmin + '&isLoginProtection=' + this.$route.query.isLoginProtection + '&isLock=' + this.$route.query.isLock + '&fromPath=addPerson')
                    this.loadingSave = false
                  })
                  .catch(err => {
                    this.loadingSave = false
                    this.$commonfun.console.log(err)
                  })
              })
              .catch(err => {
                console.log(err)
                if (err.data.code === 10053 && err.status === 400) {
                  this.$commonfun.confirm(this.$t('LanguageLib.z_info_common_000039'), this.$t('LanguageLib.INFORMATION'), this.$t('LanguageLib.YES'), this.$t('LanguageLib.NO'), false, 'info', this)
                    .then(() => {
                      basicdataApi.UserRecover('get', '/user/recover', { useraccount: this.ruleForm.userAccount })
                        .then(res => {
                          this.loadingSave = false
                          this.$message({
                            type: 'success',
                            message: this.$t('LanguageLib.SUCCESSFUL_RECOVERY')
                          })
                          this.$router.push('/basicdata/personnelmanagement?currentPage=' + this.$route.query.currentPage + '&pageSize=' + this.$route.query.pageSize + '&checkDomainId=' + this.$route.query.checkDomainId + '&searchText=' + this.$commonfun.encodeUrl(this.$route.query.searchText) + '&sort=' + this.$route.query.sort + '&isAsc=' + this.$route.query.isAsc + '&gender=' + this.$route.query.gender + '&roleIds=' + this.$route.query.roleIds + '&ranks=' + this.$route.query.ranks + '&isAdmin=' + this.$route.query.isAdmin + '&isLoginProtection=' + this.$route.query.isLoginProtection + '&isLock=' + this.$route.query.isLock + '&fromPath=addPerson')
                          this.loadingSave = false
                        })
                        .catch(err => {
                          this.loadingSave = false
                          this.$commonfun.console.log(err)
                        })
                    }).catch(() => {
                      this.loadingSave = false
                    })
                } else {
                  this.loadingSave = false
                  this.$commonfun.console.log(err)
                }
              })
          } else {
            delete this.ruleForm.userProfileDto.defaultUDPDto
            basicdataApi.editPerson('post', '/user/update', this.ruleForm)
              .then(res => {
                this.$message({
                  type: 'success',
                  message: this.$t('LanguageLib.ADDED_SUCCESSFULLY1')
                })
                this.$router.push('/basicdata/personnelmanagement?currentPage=' + this.$route.query.currentPage + '&pageSize=' + this.$route.query.pageSize + '&checkDomainId=' + this.$route.query.checkDomainId + '&searchText=' + this.$commonfun.encodeUrl(this.$route.query.searchText) + '&sort=' + this.$route.query.sort + '&isAsc=' + this.$route.query.isAsc + '&gender=' + this.$route.query.gender + '&roleIds=' + this.$route.query.roleIds + '&ranks=' + this.$route.query.ranks + '&isAdmin=' + this.$route.query.isAdmin + '&isLoginProtection=' + this.$route.query.isLoginProtection + '&isLock=' + this.$route.query.isLock + '&fromPath=addPerson')
                this.loadingSave = false
              })
              .catch(err => {
                this.loadingSave = false
                this.$commonfun.console.log(err)
              })
          }
        } else {
          return false
        }
      })
    },
    // 重置密码
    resetPassword () {
      this.dialogReset = true
      this.SendSMS = true
      this.SendMail = false
      this.Lang = this.$commonfun.localStorage.getitem('OwnerLanguage')
    },
    // 关闭对话框  清除校验
    closeDialogReset () {
      this.dialogReset = false
    },
    // 确定重置密码
    submitReset () {
      basicdataApi.DelPersonList('post', '/user/resetpwd', {
        SendSMS: this.SendSMS,
        SendMail: this.SendMail,
        Ids: this.$route.query.id.split(','),
        Lang: Number(this.Lang)
      })
        .then(res => {
          this.$message({
            type: 'success',
            message: this.$t('LanguageLib.PASSWORD_RESET_SUCCEEDED')
          })
          this.dialogReset = false
        })
        .catch(err => {
          this.$commonfun.console.log(err)
        })
    },
    // 如果没有选择组织的时候给提示
    showTit () {
      this.$message({
        type: 'info',
        message: this.$t('LanguageLib.PLEASE_BEFORE_SELECT_ORGANIZATION')
      })
    }
  },
  watch: {
    showQyUserName (value) {
      if (value) {
        this.ruleForm.userProfileDto.firstName = this.wxUserid + ''
      }
    }
  }
}
</script>

<style lang="scss">
  .Addperson {
    .TeInput input {
      border-right: 0px;
      border-radius: 4px 0 0 4px;
    }
    .return {
      padding-left: 25px;
      position: relative;
      height: 50px;
      background: rgba(255, 255, 255, 1);
      line-height: 50px;
      border-bottom: 1px solid #F2F2F2;
      .el-icon-back {
        margin-right: 15px;
        cursor: pointer;
      }
      .border {
        position: absolute;
        height: 37px;
        border-left: 1px solid #f1f1f1;
        display: inline-block;
        top: 5px;
      }
      .title {
        height: 25px;
        font-size: 18px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 1);
        margin-left: 15px;
      }
    }
    .content::-webkit-scrollbar {
      width: 10px;
      height: 10px;
    }
    .content::-webkit-scrollbar-thumb {
      border-radius: 5px;
      -webkit-box-shadow: inset 0 0 5px rgba(255, 255, 255, 0.2);
      background: #E1E1E1;
    }
    .content::-webkit-scrollbar-track {
      -webkit-box-shadow: inset 0 0 5px rgba(255, 255, 255, 0.2);
      border-radius: 5px;
      background: #fff;
    }
    .content {
      background: rgba(255, 255, 255, 1);
      width: 100%;
      height: calc( 100% - 66px);
      overflow-y: auto;
      padding: 0 100px;
      padding-top: 15px;
      box-sizing: border-box;
      .drawerText {
        margin-bottom: 5px;
        height: 16px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(77, 77, 77, 1);
        line-height: 16px;
      }
      h4 {
        font-size: 16px;
        color: #000;
        font-weight: normal;
        padding-top: 8px;
      }
      .contentTop{
        padding: 15px 0 24px 20px;
        .el-checkbox{
          margin-right: 30px;
        }
      }
      .infoForm {
        padding: 15px 0 0 20px;
        .parent {
          width: 50%;
          display: inline-block;
        }
      }
    }
     /*修改按钮样式*/
    .el-button--primary {
      background-color: #3BC6B9;
      border-color: #3BC6B9;
      height: 30px;
      padding: 7px 20px;
      margin-bottom: 15px;
      margin-left: 0;
    }
    .colorRed {
      color: red;
    }
     /*组织树视图*/
    .el-dialog {
      overflow: hidden;
      .left {
        background: #fff;
        width: 320px;
        height: 535px;
        border: 1px solid #f2f2f2;
        .fifter {
          height: 30px;
          padding: 10px 0 10px 20px;
          margin: 0 auto;
          border-bottom: 1px solid #f2f2f2;
          .el-input {
            width: 220px;
            input {
              height: 30px;
              line-height: 30px;
              border-radius: 20px;
            }
            .el-icon-search {
              line-height: 30px;
            }
          }
          .el-button--text {
            margin-left: 8px;
            padding: 7px 0;
            color: #3BC6B9;
          }
        }
        .treeBox {
          height: calc( 100% - 51px);
          overflow: auto;
          width: 320px;
        }
        .treeBox::-webkit-scrollbar {
          width: 10px;
          height: 10px;
        }
        .treeBox::-webkit-scrollbar-thumb {
          border-radius: 5px;
          -webkit-box-shadow: inset 0 0 5px rgba(255, 255, 255, 0.2);
          background: #E1E1E1;
        }
        .treeBox::-webkit-scrollbar-track {
          -webkit-box-shadow: inset 0 0 5px rgba(255, 255, 255, 0.2);
          border-radius: 5px;
          background: #fff;
        }
      }
    }
    .el-textarea__inner {
      font: 400 13.3333px Arial;
    }
    .el-pagination{
      padding: 8px 15px 5px;
    }
  }
.el-range-editor.el-input__inner{
  width: 320px;
}
.superiorDialog{
  .el-dialog{
    height: calc(100% - 170px);
    width: 1000px !important;
    .el-dialog__body{
      padding-top: 0;
      height: calc(100% - 84px);
      .operationSearch{
        overflow: hidden;
        margin-bottom: 10px;
        .el-input{
          width: 160px;
          float: right;
          .el-input__inner{
            height: 30px;
            line-height: 30px;
            border-radius: 20px;
          }
        }
        .el-icon-search{
          line-height: 30px;
        }
      }
      .tableParent{
        height: calc(100% - 77px);
        border: 1px solid #EBEEF5;
        border-bottom: 0;
      }
    }
  }
}
.resetDialog{
  .el-dialog{
    width: 420px !important;
    .el-dialog__body{
      padding: 10px 20px 30px;
      .parent{
        margin: 15px 0;
      }
    }
  }
}
.DialogInfo{
  .el-dialog{
    width: 420px !important;
    .el-dialog__body{
      padding: 10px 20px 30px;
      .parent{
        margin: 15px 0;
      }
    }
  }
}

.el-textarea{
  textarea{
    height: 124px;
  }
}
</style>
